module.exports = __webpack_public_path__ + "img/nam-san-home.7954fa2f.jpg";